module.exports = __webpack_public_path__ + "static/img/cigale-aile.af7c691f.svg";